import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { QualifiedShareDividendFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import * as Yup from "yup";
import { QualifiedShareDividendRejectFormContainerProps } from "models/propTypes/qualifiedShareDividendsPropTypes";
import { store } from "store";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region components
import QualifiedShareDividendRejectForm from "./rejectForm";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion

const QualifiedShareDividendRejectFormContainer: ForwardRefRenderFunction<
  FormHandles,
  QualifiedShareDividendRejectFormContainerProps
> = (props, ref) => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  const validationSchema = Yup.object<QualifiedShareDividendFormTypes.Reject>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: QualifiedShareDividendFormTypes.Reject) => {
    return qualifiedShareDividendsService
      .rejectDividend(props.id, values.message)
      .then((res) => store.dispatch(closeDialog()));
  };

  return (
    <QualifiedShareDividendRejectForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(QualifiedShareDividendRejectFormContainer);
